// ═══════════════════════════════════════════════════════════════════════════
//  src/pages/BienvenidaPage.jsx
//  UN PUENTE, NO UNA PANTALLA
//
//  Esto era la pantalla a la que iba a parar quien verificaba su correo, y fue
//  un error de bulto. Rob, el 11-09-2026:
//
//    «tenemos un registro para llegar y validar, pero se queda ahí, sin pasar
//     al siguiente nivel. Me lanza otra pestaña, y no parece lo mismo; la idea
//     es que valide en la misma pantalla y continuar… al dar clic se pone una
//     nueva pantalla, eso es un error porque no se siente lo mismo».
//
//  El recorrido ahora empieza y acaba en `/verify-email`, que es donde el
//  alumno estaba esperando: la barra pasa de «Verificar» a «Aprender» y las
//  opciones salen ahí mismo. El contenido vive en `components/YaEstasDentro`.
//
//  ── POR QUÉ SIGUE EXISTIENDO ESTA RUTA ─────────────────────────────────────
//  Porque hay correos ya enviados que apuntan a `/bienvenida`, y un enlace de
//  verificación vale dos días. Borrarla dejaría a esa gente en una pantalla en
//  blanco justo en el paso que decide si entran o no. Redirige conservando los
//  parámetros, así que lo que reciben es lo mismo que los que llegan hoy.
// ═══════════════════════════════════════════════════════════════════════════

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export default function BienvenidaPage() {
    const { search } = useLocation();
    // Sin `verificado=1` no se puede afirmar nada: se llega igual, y la pantalla
    // de destino ya sabe qué enseñar cuando no consta que haya verificado.
    return <Navigate to={`/verify-email${search}`} replace />;
}
